import {ArrowDownTrayIcon, ClipboardIcon, PrinterIcon} from '@heroicons/react/24/outline'
import {copyToClipboard, saveGridImage} from '../util/helpers'

export default function ShareControls({ worksheetUrl, shareableGridRef }) {
  return (
    <div className="share-controls p-4 mt-8 bg-gray-50 rounded-lg">
      <h3 className="text-lg font-medium mb-4">{Drupal.t('Share word grid')}</h3>
      <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="worksheetUrl">{Drupal.t('Shareable link')}:</label>
      <div className="flex flex-col sm:flex-row justify-end gap-2">
        <div className="flex-1 flex flex-col sm:flex-row gap-2 sm:gap-0">
          <input type="text" readOnly={true} value={worksheetUrl} id="worksheetUrl"
                 className="flex-1 px-3 py-2 border border-gray-300 rounded-md sm:rounded-r-none focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" />
          <button onClick={() => copyToClipboard(worksheetUrl)}
                  className="bg-primary text-white px-4 py-2 rounded-md sm:rounded-l-none cursor-pointer hover:bg-primary-lighter keep-in-pure-printable">
            <ClipboardIcon className="size-5 inline mr-2" />
            <span className="align-middle">{Drupal.t('Copy')}</span>
          </button>
        </div>
        <button onClick={() => saveGridImage(shareableGridRef.current)}
                className="bg-primary text-white px-4 py-2 rounded-md cursor-pointer hover:bg-primary-lighter keep-in-pure-printable">
          <ArrowDownTrayIcon className="size-5 inline mr-2" />
          <span className="align-middle">{Drupal.t('Save')}</span>
        </button>
        <button onClick={() => window.print()}
                className="bg-primary text-white px-4 py-2 rounded-md cursor-pointer hover:bg-primary-lighter keep-in-pure-printable">
          <PrinterIcon className="size-5 inline mr-2" />
          <span className="align-middle">{Drupal.t('Print')}</span>
        </button>
      </div>
    </div>
  )
}
